// DeviceSizeHandler.js
import { connect } from 'react-redux';

import DeviceSizeHandler from '../component/DeviceSizeHandler.jsx';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import calculatePopupNotificationSize from '../action/calculatePopupNotificationSize.js';

const mapDispatchToProps = dispatch => {
  return {
    setDeviceSize: ({ width, height }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['device'],
          data: {
            width,
            height,
          },
        },
      }),
    calculatePopupNotificationSize: () =>
      dispatch(calculatePopupNotificationSize()),
  };
};

export default connect(null, mapDispatchToProps)(DeviceSizeHandler);
